import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const AuthImage = ({ path, alt, className, testId, fallback }) => {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let url = null;
    setErr(false);
    api.get(path, { responseType: "blob" }).then((r) => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => { setSrc(null); setErr(true); });
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [path]);
  if (err && fallback !== undefined) return fallback;
  if (!src) return <div className={`${className} bg-muted animate-pulse`} />;
  return <img src={src} alt={alt} className={className} data-testid={testId} />;
};
